// extracted by mini-css-extract-plugin
export default {"group":"EditorMenu_group__Bswl+","active":"EditorMenu_active__w7njm"};